var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "goods_drawer_basic_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "name" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("产品抽屉名称")]),
          _c("el-input", {
            attrs: { placeholder: "输入10个字以内的名称", clearable: "" },
            model: {
              value: _vm.value.config.name,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "name", $$v)
              },
              expression: "value.config.name",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "more_name" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("查看更多按钮展示为")]),
          _c("el-input", {
            attrs: { placeholder: "输入10个字以内的名称", clearable: "" },
            model: {
              value: _vm.value.config.more_name,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "more_name", $$v)
              },
              expression: "value.config.more_name",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "bg_color",
          staticStyle: { "margin-bottom": "0" },
          attrs: { prop: "bg_color" },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v("产品展示区背景色")]),
          _c("el-color-picker", {
            model: {
              value: _vm.value.config.bg_color,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "bg_color", $$v)
              },
              expression: "value.config.bg_color",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "id" } },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v("给「查看更多」设置菜单"),
          ]),
          _c("el-cascader", {
            staticStyle: { width: "100%" },
            attrs: {
              options: _vm.menuListFilter,
              "collapse-tags": "",
              props: {
                label: "show_name",
                value: "id",
                children: "childrens",
                checkStrictly: true,
                emitPath: false,
              },
              filterable: "",
              clearable: "",
              placeholder: "选择菜单",
            },
            model: {
              value: _vm.value.config.id,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "id", $$v)
              },
              expression: "value.config.id",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "sort", attrs: { prop: "sort" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("产品展示逻辑")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.sort,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "sort", $$v)
                },
                expression: "value.config.sort",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio" },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [
                    _vm._v(" 按商品列表默认排序（即按商品ID大到小） "),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio" },
                [
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v(" 按商品更新时间倒序展示（更新时间晚到早） "),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio" },
                [
                  _c("el-radio", { attrs: { label: "3" } }, [
                    _vm._v(" 按商品排序值正序展示（即按商品排序值小到大） "),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }